export const isEnglishLocale = (locale: string): boolean => {
	// English locale or starts with 'en-', `en-US`, `en-GB`, etc.
	return locale.toLowerCase().startsWith('en');
};
